<app-header-three></app-header-three>
<!-- Register Form Start -->
<div class="section">

    <div class="imgs-wrapper">
      <img src="assets/img/veg/11.png" alt="veg" class="d-none d-lg-block">
      <img src="assets/img/veg/2.png" alt="veg" style="bottom: 100px" class="d-none d-lg-block">
    </div>

    <div class="container">
      <div class="auth-wrapper">

        <div class="auth-description bg-cover bg-center dark-overlay dark-overlay-2" style="background-image: url('assets/img/veg/cta-2.jpg')">
          <div class="auth-description-inner">
            <i class="flaticon-chili"></i>
            <h2>Sign Up</h2>
          </div>
        </div>
        <div class="auth-form">

          <h2>Sign Up</h2>
            <div class="">
			  <div *ngIf="registrationMessage!=''" class="alert alert-primary">
				  <strong> {{registrationMessage}} </strong>
 				</div>
			  </div>
			<form [formGroup]="registrationForm" class="login-container" (ngSubmit)="registration()" autocomplete="off" >
			<div class="input-group mb-3"
				[ngClass]="{ 'has-error': isSubmitted && formControls.phone_no.errors }"
			>
			  <div class="input-group-prepend">
				<span class="input-group-text" id="basic-addon1">
				<img src="assets/img/Flag_of_the_U.S..svg" style="width:30px">
				</span>
			  </div>
			  <input type="number" class="phone_no form-control "
			  placeholder="5555555555" name="phone_no"
			  formControlName="phone_no"
			  onKeyPress="if(this.value.length==10) return false;"
			  autocomplete="off"
			  >
			  
			</div>
			<!-- <div class="form-group">
			  
			  <div  style="text-align: left;color: red;" class="invalid-number">
				Phone number must be valid USA format i.e 1 555 555 5555
			  </div>
            </div> -->
			<div class="form-group">
			  <p [ngClass]="{ 'has-error': isSubmitted && formControls.fullname.errors }">
			
              <input type="text" class="fullname form-control form-control-light"
			  formControlName="fullname"
			  placeholder="Full Name" name="fullname"  
			  autocomplete="off"
			 	>
			  </p>
			</div>
            <div class="form-group">
			  <p [ngClass]="{ 'has-error': isSubmitted && formControls.email.errors }">
			
              <input type="email" class="email form-control form-control-light"
			  formControlName="email"
			  placeholder="Email" name="new" value=""
			  autocomplete="off"
			  >
			  </p>
			  <div  *ngIf="formControls.email.errors"
			  style="text-align: left;color: red;">
				<span *ngIf="formControls.email.errors.email">Email must be a valid email address</span>
			  </div>

			</div>
            <div class="form-group">
			  <p [ngClass]="{ 'has-error': isSubmitted && formControls.password.errors }">
			
              <input type="password" class="password form-control form-control-light"
			  formControlName="password"
			  placeholder="Password" name="password" value=""
			 autocomplete="new-password"
			  >
			  </p>
            </div> 
			<div class="form-group">
			  <p [ngClass]="{ 'has-error': isSubmitted && formControls.confirmPassword.errors }">
			
              <input type="password" class="password form-control form-control-light"
			  formControlName="confirmPassword"
			  placeholder="Confirm Password" name="confirmPassword" value="">
			  </p>
            </div>
			<p style="text-align: left;font-weight: 600;"><input type="checkbox" id="agree-term-condition"> I agree to the <span style="cursor:pointer" (click)="termConditionIframe()"> <span style="color: blue;">term</span> & <span style="color: blue;">conditions</span> </span></p>
			<!-- onfocus="this.removeAttribute('readonly');"
		    onblur="this.setAttribute('readonly','');" -->
			 
            <button type="submit" *ngIf="!registrationSpin" class="btn-custom primary">Sign Up</button>
            <div  *ngIf="registrationSpin" class="category-box-icon d-flex">
				<i class="fas fa-spinner spinner"></i>
				</div>
            <div class="auth-seperator">
              <span>OR</span>
            </div>

            <div class="social-login">
			  <div  *ngIf="registerSpinGoogle" class="category-box-icon d-flex">
				<i class="fas fa-spinner spinner"></i>
			  </div>
			  
              <button type="button" class="ct-social-login facebook d-none"><i class="fab fa-facebook-f"></i> Continue with Facebook </button>
              <button type="button" *ngIf="!registerSpinGoogle" class="d-none ct-social-login google" (click)="signupWithGoogle()"><i class="fab fa-google"></i> Continue with Google</button>
            </div>

            <p>Already have an account? <a routerLink='/login'>Login</a> </p>

          </form>
        </div>

      </div>
    </div>
  </div>
  <!-- Register Form End -->

<div class="modal fade" id="termandconditions" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg" role="document" style="margin-top: 0px;">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Terms & Conditions </h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body" style="padding-top: 8px;">
		<iframe height="100%" width="100%"
		 id="termandconditions-iframe"
		 src="">
		</iframe>
		
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>  
  
  
<app-footer></app-footer>